import instance from "../components/general/AxiosInterceptor";
const controller = "/api/view-user";

export const createSuperVisorApi = (payload) => {
  return instance.post(`${controller}/create-validator`, payload);
};

export const searchSuperVisorsApi = async (body, params) => {
  const response = await instance.post(`${controller}/list?page=${params.page}&size=${params.pageSize}`, { ...body }); 
  return response.data?.body;
};

export const updateSuperVisorApi = async (superVisorId, body) => {
  const response = await instance.put(`${controller}/update/${superVisorId}`, body);
  return response.data;
};

export const getSuperVisorByIdApi = async (superVisorId) => {
  const response = await instance.get(`${controller}/info/${superVisorId}`); 
  return response.data.body;
};

export const switchActivationApi = (superVisorId) => {
  return instance.put(`${controller}/switch-activation/${superVisorId}`, {});
}

export const deleteSuperVisorApi = (superVisorId) => {
  return instance.delete(`${controller}/delete/${superVisorId}`, {});
}
